import React from 'react';


function Dashboard ()  {
    return <h1>hello</h1>

};

export default Dashboard;